import { render, staticRenderFns } from "./NotificationEditForm.vue?vue&type=template&id=527f0c33&"
import script from "./NotificationEditForm.vue?vue&type=script&lang=js&"
export * from "./NotificationEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports